export type Theme = 'dark' | 'light' | 'system';

const KEY = 'pricymayky-theme-v1';

export function getStoredTheme(): Theme {
  const stored = localStorage.getItem(KEY);
  return stored === 'dark' || stored === 'light' || stored === 'system' ? stored : 'dark';
}

export function applyTheme(theme: Theme): void {
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  document.documentElement.classList.toggle('dark', theme === 'dark' || (theme === 'system' && prefersDark));
  localStorage.setItem(KEY, theme);
}
